module.exports = __webpack_public_path__ + "static/media/login.5b06275b.mp4";